import React from 'react';
import ContentLoader from 'react-content-loader';

const MessageTableLoader = props => {
    const random = Math.random() * (1 - 0.7) + 0.7;
    return (
        <div
            style={{
                backgroundColor: 'var(--color-background-primary)',
            }}
        >
            <ContentLoader height={60} width={1060} speed={2} {...props}>
                <rect x='3' y='15' rx='4' ry='4' width='10' height='12' />
                <rect x='400' y='13' rx='6' ry='6' width={200 * random} height='12' />
                <rect x='850' y='13' rx='6' ry='6' width={78} height='12' />
                <rect x='950' y='13' rx='6' ry='6' width={40} height='12' />

                <rect x='0' y='39' rx='6' ry='6' width='1060' height='.3' />
            </ContentLoader>
        </div>
    );
};

export default MessageTableLoader;
